import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import ScrollToTop from "./components/ScrollToTop";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import ProjectsGrid from "./components/ProjectsGrid";
import ProjectDetail from "./components/ProjectDetail";
import About from "./components/About";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PhantomClaimLanding from "./components/launches/PhantomClaimLanding";
import TheatreAnnouncementLanding from "./components/launches/TheatreAnnouncementLanding";
import SongsOfSongsLanding from "./components/launches/SongsOfSongsLanding";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import { organizationSchema, websiteSchema } from "./utils/structuredData";

const Home = () => {
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, websiteSchema]
  };

  return (
    <div className="min-h-screen bg-black">
      <SEO
        title="Infinite Reyn Productions | Where Stories Take Form - Books, Music, Theatre"
        description="A multi-disciplinary creative house built for stories that refuse to stay in one form. Discover paranormal romance by Evie Montclaire, worship music by Divine Reyn, and provocative theatre productions."
        canonical="/"
        keywords="Infinite Reyn Productions, Evie Montclaire books, Divine Reyn music, theatre productions, paranormal romance, worship music, creative house, Songs of Songs album, The Phantom Claim, Fenmor Pack series"
        structuredData={combinedSchema}
      />
      <Navigation />
      <Hero />
      <IntroSection />
      <ProjectsGrid />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/launch/the-phantom-claim" element={<PhantomClaimLanding />} />
          <Route path="/launch/theatre-announcement" element={<TheatreAnnouncementLanding />} />
          <Route path="/launch/songs-of-songs" element={<SongsOfSongsLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
